exports.init = function($) {

    //scrollable sections
    $('.scroll-right').click(function() {
        var elWidth = $(this).siblings('.medium-slider').width();

        $(this).parent('.scrollable').animate({ // smooth scroll
            scrollLeft: elWidth
        }, 300, 'swing')
    });

    $('.scroll-left').click(function() {

        $(this).parent('.scrollable').animate({ // smooth scroll
            scrollLeft: 0
        }, 300, 'swing')
    });

    //table scrolling
    $('.scroll-right').click(function() {
        var elWidth = $(this).siblings('table').width();

        $(this).parent('.table-container').animate({ // smooth scroll
            scrollLeft: elWidth
        }, 300, 'swing')
    });

    $('.scroll-left').click(function() {

        $(this).parent('.table-container').animate({ // smooth scroll
            scrollLeft: 0
        }, 300, 'swing')
    });

    //Scroll listener for touchscreen scroller and page load
    if ($(".scrollable").length) {
        var thisEL = $(".scrollable");
        var scrollLeft = $(".scrollable").scrollLeft();
        var scrollWidth = $(".scrollable")[0].scrollWidth - $(".scrollable")[0].clientWidth;

        if(scrollLeft == 0) {
            $(thisEL).addClass('scrollLeft');
            $(thisEL).removeClass('scrollRight');
        } else if(scrollLeft == scrollWidth) {
            $(thisEL).addClass('scrollRight');
            $(thisEL).removeClass('scrollLeft');
        } else {
            $(thisEL).removeClass('scrollRight').removeClass('scrollLeft');
        }
    }

    $(".scrollable").scroll(function(e) {
        var scrollLeft = $(this).scrollLeft();
        var scrollWidth = $(this)[0].scrollWidth - $(this)[0].clientWidth;

        if(scrollLeft == 0) {
            $(this).addClass('scrollLeft');
            $(this).removeClass('scrollRight');
        } else if(scrollLeft == scrollWidth) {
            $(this).addClass('scrollRight');
            $(this).removeClass('scrollLeft');
        } else {
            $(this).removeClass('scrollRight').removeClass('scrollLeft');
        }
    });

    // $('.stories-wrapper').slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     dots: true,
    //     arrows: false,
    //     infinite: false
    // });
}